export const IsResponseDataValid = (response) => {
    if (!response) return false;
    if (!response.data) return false;
    if (!response.data.value) return false;
    if (response.data.value.length == 0) return false;

    return true;
}

export const durationToTime = (durationStr) => {
    const match = durationStr.match(/PT(?:(\d+)H)?(?:(\d+)M)?/);

    if (!match) return null;

    const hours = parseInt(match[1] || "0", 10);
    const minutes = parseInt(match[2] || "0", 10);

    // Create a time-only Date (1970-01-01 base)
    return new Date(1970, 0, 1, hours, minutes);
}

export const to24Hour = (timeValue) => {
    const d = new Date(timeValue);
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    return `${hh}:${mm}`;
};

export const from24toDate = (timeStr) => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    return new Date(1970, 0, 1, hours, minutes);
};

export const minutesTo24Hour = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const hh = String(hours).padStart(2, "0");
    const mm = String(minutes).padStart(2, "0");
    return `${hh}:${mm}`;
};

export function timeStringToMinutes(str) {
    if (!str || !str.includes(":")) return 0;
    const [h, m] = str.split(":").map(Number);
    return h * 60 + m;
}
